import { Injectable } from '@angular/core';
import { defer, Observable, share, Subject, switchMap, take, throwError, of, finalize } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProtectedActionsService {
    readonly reAuthRequired$: Subject<void> = new Subject<void>();

    private pendingReAuth$: Observable<void> | null = null;
    private reAuthResult$: Subject<Error | null> = new Subject<Error | null>();

    requestReAuth(): Observable<void> {
        if (!this.pendingReAuth$) {
            this.pendingReAuth$ = defer(() => {
                this.reAuthRequired$.next();
                return this.reAuthResult$;
            }).pipe(
                take(1),
                switchMap(result => result ? throwError(() => result) : of(undefined)),
                finalize(() => { this.pendingReAuth$ = null; }),
                share()
            );
        }
        return this.pendingReAuth$;
    }

    completeReAuth(): void {
        this.reAuthResult$.next(null);
    }

    cancelReAuth(): void {
        this.reAuthResult$.next(new Error('Re-authentication cancelled'));
    }
}
